import { useTransform, motion, useScroll, useMotionValue } from "framer-motion"; // Import useMotionValue
import { useRef } from "react";
import { Typography } from "@mui/material";
import "./Card.css"; // Import CSS file

const Card = (props) => {
  const {
    i,
    title,
    description,
    src,
    url,
    color,
    progress = 0, // Set default value for progress
    range = [0, 1], // Set default value for range
    targetScale,
  } = props;
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start end", "start start"],
  });

  // Ensure progress is a motion value
  const motionProgress = useMotionValue(progress);

  // Use motion values
  const imageScale = useTransform(scrollYProgress, [0, 1], [2, 1]);
  const scale = useTransform(motionProgress, range, [1, targetScale]);

  // Ensure description is an array
  const descriptionArray = Array.isArray(description)
    ? description
    : [description];

  return (
    <div ref={container} className="cardContainer">
      <motion.div
        style={{
          backgroundColor: color,
          scale,
          top: `calc(-5vh + ${i * 25}px)`,
        }}
        className="card"
      >
        <h2
          style={{
            fontFamily: "Light",
            marginBottom: 5,
            fontSize: { xs: 8, sm: 8, md: 10, lg: 10, xl: 16 },
          }}
        >
          {title}
        </h2>
        <div
          // className="imageContainer"
          style={{
            overflow: "hidden",
            borderRadius: 25,
          }}
        >
          <motion.div className="inner" style={{ scale: imageScale }}>
            <img
              src={`/images/${src}`}
              alt={title}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </motion.div>
        </div>
        <div style={{ padding: 4, marginTop: 10 }}>
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            {descriptionArray.map((item, index) => (
              <li
                key={index}
                style={{
                  // marginBottom: "4px",
                  lineHeight: "1.2",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Light",
                    fontSize: {
                      xs: 10,
                      sm: 12,
                      md: 14,
                      lg: 16,
                      xl: 16,
                    },
                    textAlign: "start",
                    display: "inline",
                  }}
                >
                  {item}
                </Typography>
              </li>
            ))}
          </ul>

          <span>
            <a href={url} target="_blank" rel="noreferrer noopener">
              <Typography
                sx={{
                  fontFamily: "Light",
                  fontSize: {
                    xs: 10,
                    sm: 12,
                    md: 14,
                    lg: 16,
                    xl: 16,
                  },
                  textAlign: "start",
                  display: "inline",
                }}
              >
                See more...
              </Typography>
            </a>
            {/* <svg
              width="22"
              height="12"
              viewBox="0 0 22 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.5303 6.53033C21.8232 6.23744 21.8232 5.76256 21.5303 5.46967L16.7574 0.696699C16.4645 0.403806 15.9896 0.403806 15.6967 0.696699C15.4038 0.989592 15.4038 1.46447 15.6967 1.75736L19.9393 6L15.6967 10.2426C15.4038 10.5355 15.4038 11.0104 15.6967 11.3033C15.9896 11.5962 16.4645 11.5962 16.7574 11.3033L21.5303 6.53033ZM0 6.75L21 6.75V5.25L0 5.25L0 6.75Z"
                fill="black"
              />
            </svg> */}
          </span>
        </div>
      </motion.div>
    </div>
  );
};

export default Card;
